var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.679419 10.8681C1.25048 9.70526 2.74514 9.3596 3.76877 10.1537L7.18277 12.8021C7.66772 13.1783 8.35839 13.128 8.78363 12.6854L20.0563 0.952703C20.838 0.139039 22.106 0.0417116 23.0028 0.726529C24.0633 1.53641 24.1742 3.09252 23.2391 4.04456L9.65018 17.8806C8.74808 18.7991 7.28195 18.8422 6.32743 17.9783L1.14281 13.286C0.466252 12.6737 0.277193 11.6872 0.679419 10.8681Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-checkmark.7e057af2ef3fa92968bb03e11351f9c2.svg";